module.exports = __webpack_public_path__ + "static/media/img12.90c7562c.jpg";